export const ADDRESS_HEADER_TEXT = "Address";
export const LOCATION_KIOSK_TEXT = "Dine-In";
export const NO_DELIVERY_TEXT = " No Delivery";
export const NO_LOCATIONS_TO_DELIVER_MESSAGE =
  "\nNo locations deliver to \nyour address";
export const NO_PICKUP_TEXT = " No Pickup";
export const PICK_UP_SUGGESTION_MESSAGE = "But there’s always pick-up";
export const SEARCH_DELIVER_LOCATIONS_MESSAGE =
  "Search to see which locations deliver to your address";
export const TODAYS_DELIVERY_HOURS = "Today's Delivery Hours";
export const TODAYS_PICK_UP_HOURS = "Today's Pickup Hours";
export const TODAYS_STORE_HOURS = "Today's Store Hours";

export default {
  ADDRESS_HEADER_TEXT,
  LOCATION_KIOSK_TEXT,
  NO_DELIVERY_TEXT,
  NO_LOCATIONS_TO_DELIVER_MESSAGE,
  NO_PICKUP_TEXT,
  PICK_UP_SUGGESTION_MESSAGE,
  SEARCH_DELIVER_LOCATIONS_MESSAGE,
  TODAYS_DELIVERY_HOURS,
  TODAYS_PICK_UP_HOURS,
  TODAYS_STORE_HOURS,
};
